import React from 'react';

import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ArticleIcon from '@mui/icons-material/Article';
import BusinessIcon from '@mui/icons-material/Business';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import DescriptionIcon from '@mui/icons-material/Description';
import GroupIcon from '@mui/icons-material/Group';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import PublicIcon from '@mui/icons-material/Public';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import SourceIcon from '@mui/icons-material/Source';
import List from '@mui/material/List';

import { AuthContext } from '../../contexts/AuthContext';
import NavItem from './NavItem';
import RoleHeader from './RoleHeader';

// TODO: remove before push to PROD
const canReadClaimsTools = ['development', 'staging', 'preview'].includes(
  process.env.NODE_ENV,
);

const Navigation = React.memo(({ collapsed }) => {
  const { canRead, isCrawOnly } = React.useContext(AuthContext);

  return (
    <List
      id="sidebar-navigation"
      component="nav"
      aria-label="Main navigation"
      sx={{ flex: 1, pb: 2 }}
    >
      {!isCrawOnly() && (
        <NavItem
          collapsed={collapsed}
          icon={<HomeIcon />}
          text="Home"
          path="/"
        />
      )}

      {canRead('accounts') && (
        <>
          <RoleHeader collapsed={collapsed} header={'Customers'} />
          <NavItem
            collapsed={collapsed}
            icon={<BusinessIcon />}
            text="Companies"
            path="/companies"
          />
          <NavItem
            collapsed={collapsed}
            icon={<DescriptionIcon />}
            text="Contracts"
            path="/contracts"
          />
          <NavItem
            collapsed={collapsed}
            icon={<RequestPageIcon />}
            text="Billing"
            path="/billing"
          />
        </>
      )}

      {isCrawOnly() && (
        <>
          <RoleHeader collapsed={collapsed} header={'Claims'} />
          <NavItem
            collapsed={collapsed}
            icon={<HistoryIcon />}
            text="Companies"
            path="/companies"
          />
          <NavItem
            collapsed={collapsed}
            icon={<BusinessCenterIcon />}
            text="Service Providers"
            path="/service-providers"
          />
          <NavItem
            collapsed={collapsed}
            icon={<SourceIcon />}
            text="Navigator"
            path="/resources"
          />
        </>
      )}

      {(canRead('care') || canRead('member_stats')) && (
        <>
          <RoleHeader collapsed={collapsed} header={'Members'} />
          <NavItem
            collapsed={collapsed}
            icon={<GroupIcon />}
            text="Members"
            path="/members"
          />
          <NavItem
            collapsed={collapsed}
            icon={<HeadsetMicIcon />}
            text="Consultations"
            path="/consultations"
          />
        </>
      )}

      {(canRead('claims') ||
        canRead('wallets') ||
        canRead('invoice_training') ||
        canRead('ai_pipeline')) && (
        <>
          <RoleHeader collapsed={collapsed} header={'Claims & Wallets'} />
          {canRead('claims') && (
            <>
              <NavItem
                collapsed={collapsed}
                icon={<PointOfSaleIcon />}
                text="Claims"
                path="/claims"
              />
              {canReadClaimsTools && (
                <NavItem
                  collapsed={collapsed}
                  icon={<PointOfSaleIcon />}
                  text="Claims tool"
                  path="/claims-tool"
                />
              )}
            </>
          )}
          {canRead('wallets') && (
            <NavItem
              collapsed={collapsed}
              icon={<AccountBalanceWalletIcon />}
              text="Wallets overview"
              path="/wallets"
            />
          )}
          {canRead('wallets') && (
            <NavItem
              collapsed={collapsed}
              icon={<AccountBalanceWalletIcon />}
              text="Wallet transactions"
              path="/wallet-transactions"
            />
          )}
          {canRead('invoice_training') && (
            <NavItem
              collapsed={collapsed}
              icon={<ReceiptLongIcon />}
              text="Invoice training"
              path="/invoice-training"
            />
          )}
          {canRead('ai_pipeline') && (
            <NavItem
              collapsed={collapsed}
              icon={<ChatBubbleOutlineOutlinedIcon />}
              text="AI pipelines"
              path="/ai-pipelines"
            />
          )}
        </>
      )}

      {!isCrawOnly() && (
        <>
          <RoleHeader collapsed={collapsed} header={'General'} />
          <NavItem
            collapsed={collapsed}
            icon={<QueryStatsIcon />}
            text="Stats"
            path="/stats"
          />
        </>
      )}
      {canRead('treatments') && (
        <NavItem
          collapsed={collapsed}
          icon={<ChildFriendlyIcon />}
          text="Treatments"
          path="/treatments"
        />
      )}
      {canRead('annexes') && (
        <NavItem
          collapsed={collapsed}
          icon={<ArticleIcon />}
          text="Annexes"
          path="/annexes"
        />
      )}
      {canRead('navigator') && (
        <NavItem
          collapsed={collapsed}
          icon={<PublicIcon />}
          text="Navigator (L1)"
          path="/navigator-one"
        />
      )}
      {canRead('admins') && (
        <NavItem
          collapsed={collapsed}
          icon={<AdminPanelSettingsIcon />}
          text="Admins"
          path="/admins"
        />
      )}
    </List>
  );
});

Navigation.displayName = 'Navigation';

export default Navigation;
